import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-clients-services',
  templateUrl: './clients-services.component.html',
  styleUrls: ['./clients-services.component.scss']
})
export class ClientsServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
